export const getDate = () => {
    const d = new Date();
    return `${d.getMonth()}/${d.getDate()}/${d.getFullYear()}`;
};

export const getURL = (svgUrl = '') => CL_SVGS_URL + svgUrl;

export const findSvg = (svgId) => getURL(svgId + '.svg');
